import React, { useEffect, useState } from 'react';
import Navbar from '../components/navbar';
import { useTranslation } from 'react-i18next';
import SimpleFooter from '../components/simpleFooter';
import { HashLink as Link } from 'react-router-hash-link';
import AWS from 'aws-sdk';
import { formatRelative } from 'date-fns'
import { enUS, fi } from 'date-fns/locale'
/* import BlogLeft from './blog-leftside'; */

const Blog = () => {

	const { t, i18n } = useTranslation();

	const [postListing, setPostListing] = useState([]);

	const currentLocale = i18n.language === 'fi-FI' ? fi : enUS;

	useEffect(() => {
		window.scrollTo(0, 0);

		//activate menu
		let menuNode = document.querySelector('a.om-blog')
		if (menuNode) {
			menuNode.classList.add('active')
		}
	}, [])

	useEffect(() => {
		AWS.config.region = 'eu-west-1'; // Region
		// Create a new service object
		var s3 = new AWS.S3({
			apiVersion: '2006-03-01'
		});
		function unauthenticatedRequest(operation, params, callback) {
			var request = s3[operation](params);
			request.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
			request.removeListener('sign', AWS.EventListeners.Core.SIGN);
			request.send(callback);
		}

		const params = {
			Bucket: 'ourmind-docs',
			MaxKeys: 100,
			Prefix: 'blogposts'
		}

		unauthenticatedRequest('listObjects', params, function (err, data) {

			if (err) {
				return alert('There was an error on getting blogposts: ' + err.message);
			}

			// 'this' references the AWS.Response instance that represents the response
			const href = this.request.httpRequest.endpoint.href;
			const bucketUrl = href + params.Bucket + '/' + params.Prefix + '/';

			if (!err && data && data.Contents && Array.isArray(data.Contents)) {

				// prefix length. +1 is forward slash
				const prefixLength = params.Prefix.length + 1;
				// parse content
				const fileList = data.Contents.filter(item => item.Size !== 0 && item.Key.slice(-2) === 'md').map(item => {

					// get raw file name
					const fileName = item.Key.slice(prefixLength);

					// file name, no file extension
					const postName = (() => {
						let fileNameArr = fileName.split('.')
						fileNameArr.pop() // remove extension
						return fileNameArr.join('.')
					})()

					// subtract prefix
					return {
						fileName,
						key: item.Key,
						url: encodeURIComponent(fileName),
						postName: postName,
						imageUrl: bucketUrl + encodeURIComponent(postName) + '.jpg',
						fileUrl: bucketUrl + encodeURIComponent(fileName),
						lastModified: item.LastModified,
						size: item.Size
					}
				})

				setPostListing(fileList)

			} else {
				setPostListing([])
			}
		});
	}, [])

	const blogList = postListing.map(blog => {

		let blogImageUrl = blog.imageUrl;
		// scandic letters doesn't work with url...
		if(blog.postName.startsWith("TIEDON")){
			blogImageUrl = 'https://ourmind-docs.s3-eu-west-1.amazonaws.com/blogposts/TIEDON+HANKINTA+ETA%CC%88TYO%CC%88SSA%CC%88.jpg'
		}

		return( <div className="col-md-6" key={blog.key}>
			<div className="blog-item" >
				<div className="blog-block">
					<div className="blog-box">
						<div className="overflow-hidden">
							<Link to={`blog/${blog.postName}`}>
								<img src={blogImageUrl} alt={blog.postName} className="img-fluid" />
							</Link>
						</div>
					</div>
				</div>
				<div className="blog-text">
					<Link to={`blog/${blog.postName}`}>
						<h3>{blog.fileName.slice(0, -3)}</h3>
						<p>{formatRelative(new Date(blog.lastModified), new Date(), { locale: currentLocale })}</p>
					</Link>
				</div>
			</div>
		</div>
		)
	}

	)

	return (
		<div>
			<Navbar />
			<div className="page-margin" id="blog">

				{/*breadcrumb start*/}
				<div className="breadcrumb-bg">
					<div className="container">
						<div className="row">
							<div className="col-md-6 col-sm-6 col-text-center d-align-center">
								<h2>{t('blog')}</h2>
							</div>
							<div className="col-md-6 col-sm-6 col-text-center">
								<nav aria-label="breadcrumb" className="blog-bradcrumb">
									<ol className="breadcrumb bg-transparent mb-0">
										<li className="breadcrumb-item">
											<Link smooth to="/#home">{t('home')}</Link>
										</li>
										<li className="breadcrumb-item active">
											<a href={null}>{t('blog')}</a>
										</li>
									</ol>
								</nav>
							</div>
						</div>
					</div>
				</div>
				{/*breadcrumb end*/}

				{/* 				<BlogLeft /> */}

				{/*blog Section start*/}
				<section>
					<div className="container">
						<div className="row">
							<div className="col-sm-12">
								<div className="row blog-list">
									{blogList}
								</div>
							</div>
						</div>
					</div>
				</section>
				{/*blog Section End*/}

				{/*Footer Section start*/}
				<SimpleFooter />
				{/*Footer Section End*/}
			</div>
		</div>
	);
}

export default Blog;


// WEBPACK FOOTER //
// ./src/blog/Blog.js